export const selectStyles = {
  control: (base) => ({
    ...base,
    fontSize: "1.3rem",
    border: "0",
    borderBottom: "1px solid hsl(0deg 0% 50.2%)",
    padding: "3px",
    boxShadow: "none",
    fontWeight: "400",

    "&:focus": {
      border: "0 !important",
    },
  }),

  menu: (base) => ({
    ...base,
    fontSize: "1.3rem",
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "1.3rem",
    fontWeight: "400",
  }),
};
